<template>
  <div class="rt-select">
    <van-field
      v-model="result"
      v-bind="$attrs"
      readonly
      is-link
      @click="show = !show"
    />
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        :item-height="$vanItemHeight"
        v-model="currentDate"
        type="date"
        @confirm="onConfirm"
        @cancel="show = !show"
        />
    </van-popup>
  </div>
</template>

<script>
export default {
  model: {
    prop: "selectValue"
  },
  props: {
    columns: {
      type: Array
    },
    selectValue: {
      type: String
    }
  },
  data() {
    return {
      show: false,
      result: this.selectValue,
      currentDate: new Date()
    };
  },
  methods: {
    onConfirm(value) {
      this.result = this.$format(value);
      this.show = !this.show;
    },
  },
  watch: {
    selectValue: function(newVal) {
      this.result = newVal;
    },
    result(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
